import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

export const useUpdateAccountingReference = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updateAccountingReference.useMutation({
    onSettled: () => invalidateItemQueries(utils),
  });
};
